/*
 * @Description: 数据统计
 * @Author: gao shuai
 * @Date: 2020-05-21 14:17:23
 * @LastEditTime: 2020-05-22 11:12:07
 * @LastEditors: gao shuai
 */

import api from '../services/api';
export default {
  // 游戏分区
  async gameDraw(params) { return api({ url: '/api/SelectDropDown/GetPartitionNameListAsync', method: 'get', params }); },
  /* -------------------------1.充值统计-------------------------- */
  // 充值统计
  async chargeStatic(params) { return api({ url: '/api/DataAnalysis/GetDataAnalysisRechargeCountAsync', method: 'get', params }); },
  // 代理充值统计
  async chargeMerchant(params) { return api({ url: '/api/DataAnalysis/GetAgentDataAnalysisRechargeCountAsync', method: 'get', params }); },
  /* -------------------------2.时段统计-------------------------- */
  // 时段统计
  async timeStatic(params) { return api({ url: '/api/DataAnalysis/GetDataAnalysisTimeIntervalListAsync', method: 'get', params }); },
  // 代理时段统计
  async timeMerchant(params) { return api({ url: '/api/DataAnalysis/GetAgentDataAnalysisTimeIntervalListAsync', method: 'get', params }); },
  /* -------------------------3.分区统计-------------------------- */
  // 分区统计
  async areaStatic(params) { return api({ url: '/api/DataAnalysis/GetDataAnalysisPartitionsListAsync', method: 'get', params }); },
  // 代理分区统计
  async areaMerchant(params) { return api({ url: '/api/DataAnalysis/GetAgentDataAnalysisPartitionsListAsync', method: 'get', params }); },
  /* -------------------------4.分组统计-------------------------- */
  // 分组统计
  async teamStatic(params) { return api({ url: '/api/DataAnalysis/GetDataAnalysisGroupListAsync', method: 'get', params }); },
  // 代理分组统计
  async teamMerchant(params) { return api({ url: '/api/DataAnalysis/GetAgentDataAnalysisGroupListAsync', method: 'get', params }); },
  /* -------------------------5.充值排行-------------------------- */
  // 充值排行
  async chargeRank(params) { return api({ url: '/api/DataAnalysis/GetDataAnalysisRechargeRanListAsync', method: 'get', params }); },
  // 代理充值排行
  async MerchantRank(params) { return api({ url: '/api/DataAnalysis/GetAgentDataAnalysisRechargeRanListAsync', method: 'get', params }); },
  /* -------------------------6.ISP统计-------------------------- */
  // ISP统计
  async ispStatic(params) { return api({ url: '/api/DataAnalysis/GetDataAnalysisIPSListAsync', method: 'get', params }); }
};
